// src/pages/Register.jsx - Fixed version without Hook violations
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
//import { useAIAssessment } from '../components/ai/AIAssessmentProvider';
import { Brain, CheckCircle, Clock, Shield, AlertCircle, Info } from 'lucide-react';
import RegisterComponent from '../components/auth/register';
//import MFASetup from '../components/auth/MFASetup';

const RegisterPage = () => {
  const navigate = useNavigate();
  // const { register, currentUser, isAuthenticated } = useAuth();
  // const { triggerManualAssessment } = useAIAssessment();
  // const [assessmentStatus, setAssessmentStatus] = useState(null);
  // const [pendingAssessment, setPendingAssessment] = useState(false);
  // const [showMFASetup, setShowMFASetup] = useState(false);
  const { register } = useAuth();
  const [registrationComplete, setRegistrationComplete] = useState(false);
  // Monitor when user becomes available after registration
  // useEffect(() => {
  //   if (pendingAssessment && isAuthenticated && currentUser && 
  //   currentUser.role) {
  //     const attemptAssessment = async () => {
  //       try {
  //         await triggerManualAssessment();
  //         setAssessmentStatus('complete');
  //       } catch (error) {
  //         console.warn('Assessment failed, using fallback:', error);
  //         setAssessmentStatus('fallback');
  //       } finally {
  //         setPendingAssessment(false);
  //       }
  //     };

  //     // Small delay to ensure everything is properly initialized
  //     const timeoutId = setTimeout(attemptAssessment, 1000);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [pendingAssessment, isAuthenticated, currentUser, 
  // triggerManualAssessment]);
  const [registrationMessage, setRegistrationMessage] = useState('');

  const handleRegister = async (formData) => {
    const result = await register(formData);

    if (result.success) {
      setRegistrationComplete(true);
      // setAssessmentStatus('preparing');
      // setPendingAssessment(true); // Trigger the useEffect to watch 
      // for user
      // Don't navigate immediately - show MFA setup option first
      setRegistrationMessage(result.message);
      
      // Redirect to login after 5 seconds
      setTimeout(() => {
        navigate('/login');
      }, 5000);
    }
    
    return result;
  };

  // const handleMFASetupComplete = () => {
  //   setShowMFASetup(false);
  //   navigate('/dashboard');
  
  const handleGoToLogin = () => {
    navigate('/login');
  };

  // const handleMFASetupCancel = () => {
  //   setShowMFASetup(false);
  //   navigate('/dashboard');
  // };

  // const handleSkipMFA = () => {
  //   navigate('/dashboard');
  // };

  // Assessment status indicator
  // const renderAssessmentStatus = () => {
  //   if (!assessmentStatus) return null;

  //   const statusConfig = {
  //     preparing: {
  //       icon: <Clock className="w-4 h-4 text-blue-400 animate-spin" />,
  //       message: "Preparing your personalized learning journey...",
  //       color: "bg-blue-900/20 border-blue-800 text-blue-300"
  //     },
  //     complete: {
  //       icon: <CheckCircle className="w-4 h-4 text-green-400" />,
  //       message: "Your AI-powered learning journey is ready!",
  //       color: "bg-green-900/20 border-green-800 text-green-300"
  //     },
  //     fallback: {
  //       icon: <Brain className="w-4 h-4 text-yellow-400" />,
  //       message: "Standard learning path activated.",
  //       color: "bg-yellow-900/20 border-yellow-800 text-yellow-300"
  //     }
  //   };

  //   const config = statusConfig[assessmentStatus];

  // Show success message after registration
  if (registrationComplete) {
    return (
//       <div className={`fixed bottom-4 right-4 p-4 rounded-lg border ${config.color} max-w-sm`}>
//       <div className="flex items-center space-x-2">
//         {config.icon}
//         <span className="text-sm font-medium">{config.message}</span>
//       </div>
//     </div>
//   );
// };
      <div className="min-h-screen bg-gradient-to-br from-[#04141A] to-[#04141A] flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8">
          <div className="text-center mb-6">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Registration Complete!</h2>
            <p className="text-gray-600">Your account has been created successfully.</p>
          </div>

          
  {/* // Show MFA setup prompt after successful registration
  if (registrationComplete && !showMFASetup) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#102c4a] to-[#164f3f] flex items-center 
      justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center 
            justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Registration Complete!</h2>
            <p className="text-gray-600 mt-2">Your account has been created successfully.</p>
             */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <Info className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-blue-900 mb-1">Account Activation Required</h3>
                <p className="text-sm text-blue-800">
                  {registrationMessage || 'Your account is pending administrator approval. You will be able to login once an administrator activates your account. You will be notified via email when your account is ready.'}
                </p>
              </div>
            </div>
          </div>
          {/*  onClick={() => setShowMFASetup(true)} */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
            {/* <Shield className="w-5 h-5 text-blue-600 mt-0.5 mr-3" /> */}
              <AlertCircle className="w-5 h-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
              {/* <h3 className="font-semibold text-blue-900">Secure Your Account</h3>
                <p className="text-sm text-blue-800 mt-1">
                  Enable two-factor authentication (MFA) to add an extra layer of security to your 
                  account. */}
                <h3 className="font-semibold text-yellow-900 mb-1">Next Steps</h3>
                <p className="text-sm text-yellow-800">
                  Once your account is activated, you can login using your email and password.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleGoToLogin}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              Go to Login Page
            </button>
            {/* <button
              onClick={handleSkipMFA}
              className="w-full text-gray-600 py-2 px-4 rounded-lg hover:bg-gray-50 
              transition-colors"
            >
              Skip for Now
            </button> */}
            <p className="text-center text-sm text-gray-500">
              Redirecting automatically in 5 seconds...
            </p>
          </div>
          {/* {renderAssessmentStatus()} */}
        </div>
      </div>
    );
  }
// Show MFA setup component
// if (showMFASetup) {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-[#102c4a] to-[#164f3f] flex items-center 
//     justify-center p-4">
//       <MFASetup 
//         onComplete={handleMFASetupComplete}
//         onCancel={handleMFASetupCancel}
//       />
//       {renderAssessmentStatus()}
//     </div>
//   );
// }

  return (
    <div>
      <RegisterComponent onRegisterSubmit={handleRegister} />
      {/* {renderAssessmentStatus()} */}
    </div>
  );
};

export default RegisterPage;